var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7819 6.47688C11.0397 4.37647 12.8299 2.75 15 2.75C17.3472 2.75 19.25 4.65279 19.25 7V9.14538C18.5171 9.44207 18 10.1607 18 11C18 12.1046 18.8954 13 20 13C21.1046 13 22 12.1046 22 11C22 10.1607 21.483 9.44207 20.75 9.14538V7C20.75 3.82436 18.1756 1.25 15 1.25C12.045 1.25 9.61061 3.47909 9.28663 6.34751L1.77713 20.5321C1.42454 21.1981 1.90734 22 2.66092 22H17.3391C18.0927 22 18.5755 21.1981 18.2229 20.5321L10.7819 6.47688Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatAlt);
export default __webpack_public_path__ + "static/media/hat-alt.4160199889f1ac9343ac9ea5f7d15370.svg";
export { ForwardRef as ReactComponent };